import React from "react";
import { Animated, View } from "react-native";

class BlinkingCursor extends React.Component {
    _animation = null;
    constructor(props) {
        super(props);

        this.opacity = new Animated.Value(0);
    }

    componentDidMount() {
        this.startAnimation();
    }

    componentWillUnmount() {
        this._animation = null;
    }

    startAnimation() {
        this._animation = Animated.loop(Animated.stagger(400, [
            Animated.timing(this.opacity, { toValue: 1, duration: 100 }),
            Animated.delay(100),
            Animated.timing(this.opacity, { toValue: 0, duration: 100 }),
            Animated.delay(100),
        ])
        ).start();
    }

    render() {
        const { backgroundColor = "black", width = 2, height = 24 } = this.props;
        return (
            <Animated.View style={[{ opacity: this.opacity }]}>
                <View style={{ backgroundColor, width, height }}></View>
            </Animated.View>
        );
    }
}

export default BlinkingCursor;
